// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content-container":"_5HM2qt"};